module.exports = {"id":"198784","name":"Alex Oxlade-Chamberlain","rating":"80","photo":"./data/images/photos/3/198784.png","club":{"name":"Liverpool","logo":"./data/images/clubs/Liverpool.png"},"positions":["MD","MG","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexOxlade-Chamberlain0.json
// module id = 215
// module chunks = 0